module.exports = __webpack_public_path__ + "static/media/134.3c7221e5.jpg";